import {
  AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
  TemplateRef, ViewChild
} from '@angular/core';
import { CustomTableComponent } from '../../../../shared/ui/custom-table/components/table/custom-table.component';
import { TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';
import { Utils } from '../../../../shared/utils';
import { Model184, Model184Renta, Model184Validation } from '../taxes-184.model';

export interface Model184RentaFila extends Model184Renta {
  indice: number;
  errores: number;
}

export interface Model184OrigenSolicitud {
  indice: number;
  campo: string;
}

@Component({
  selector: 'app-model-184-rentas',
  templateUrl: './model-184-rentas.component.html',
  styleUrls: ['./model-184-rentas.component.css'],
  standalone: false
})
export class Model184RentasComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: Model184;
  @Input() validaciones: Model184Validation[] = [];

  @Output() nuevo = new EventEmitter<void>();
  @Output() editar = new EventEmitter<number>();
  @Output() eliminar = new EventEmitter<number>();
  @Output() origen = new EventEmitter<Model184OrigenSolicitud>();

  @ViewChild('table', { static: false }) t1!: CustomTableComponent;
  @ViewChild('estadoTpl', { static: true }) estadoTpl!: TemplateRef<any>;
  @ViewChild('origenTpl', { static: true }) origenTpl!: TemplateRef<any>;
  @ViewChild('ingresosTpl', { static: true }) ingresosTpl!: TemplateRef<any>;
  @ViewChild('gastosTpl', { static: true }) gastosTpl!: TemplateRef<any>;
  @ViewChild('retencionesTpl', { static: true }) retencionesTpl!: TemplateRef<any>;

  tableConfig!: TableConfig;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const dinero = (valor: any) => Utils.FormatMoney(valor) + ' €';

    this.tableConfig = {
      columns: [
        { key: 'errores', label: 'Estado', sortable: false, customTemplate: this.estadoTpl, width: '110px' },
        { key: 'origen', label: 'Origen', sortable: false, customTemplate: this.origenTpl, width: '110px' },
        {
          key: 'clave', label: 'Clave', sortable: false, width: '80px',
          onCellClick: (row: Model184RentaFila) => this.editar.emit(row.indice)
        },
        { key: 'subclave', label: 'Subclave', sortable: false, width: '90px' },
        { key: 'pais', label: 'País', sortable: false, width: '70px' },
        { key: 'ingresos', label: 'Ingresos', sortable: false, customTemplate: this.ingresosTpl },
        { key: 'gastos', label: 'Gastos', sortable: false, customTemplate: this.gastosTpl },
        { key: 'renta', label: 'Renta', sortable: false, formatFn: dinero },
        { key: 'gananciasPerdidas', label: 'Ganancias o pérdidas', sortable: false, formatFn: dinero },
        { key: 'baseDeduccion', label: 'Base de deducción', sortable: false, formatFn: dinero },
        { key: 'retenciones', label: 'Retenciones', sortable: false, customTemplate: this.retencionesTpl }
      ],
      actions: [
        { label: 'Editar', icon: 'edit', callback: (row: Model184RentaFila) => this.editar.emit(row.indice) },
        { label: 'Eliminar', icon: 'delete', callback: (row: Model184RentaFila) => this.eliminar.emit(row.indice) }
      ],
      headerActions: [
        { label: 'Nueva renta', icon: 'add', type: 'button', callback: () => this.nuevo.emit() }
      ],
      filterView: 'model184Rentas',
      defaultFilter: {},
      selectable: false,
      pagination: false,
      noDataText: 'No hay rentas de la entidad en este ejercicio'
    };
  }

  ngAfterViewInit(): void {
    this.pintar();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.t1 && (changes['data'] || changes['validaciones'])) {
      this.pintar();
    }
  }

  formatoImporte(valor: any): string {
    return Utils.FormatMoney(valor) + ' €';
  }

  conOrigen(row: Model184RentaFila, campo: string): boolean {
    if (row.origen !== 'CALCULADO') return false;

    return row.clave === 'D' ? campo !== 'retenciones' : row.clave === 'K' && campo === 'retenciones';
  }

  private pintar(): void {
    if (!this.t1) return;

    const filas: Model184RentaFila[] = (this.data?.rentas || []).map((item, indice) => ({
      ...item,
      indice,
      errores: this.validaciones.filter(v => (v.key || '').startsWith(`rentas[${indice}].`) && v.type !== 'WARNING').length
    }));

    this.t1.tableState.setData(filas);
    this.t1.tableState.setTotalItems(filas.length);
  }
}
